module.exports = __webpack_public_path__ + "img/icon_statistic_on.c23a614b.svg";